import moment, { unitOfTime } from 'moment';
import { LineSegmentProps } from 'victory';
import { Ranges } from '../../../../../services/MedicalResultsService';

export type RangeIndicatorProps = {
  ranges: Ranges;
  minValue: number;
  maxValue: number;
} & LineSegmentProps;

export type MedicalResultRangeData = {
  lower: number;
  upper: number;
  status: 'in-range' | 'optimal' | 'attention';
};

/**
 * Create a range of moment dates between a start and end date in ascending order.
 *
 */
export const dateMomentRange = (
  start: moment.Moment,
  end: moment.Moment,
  unit: unitOfTime.DurationConstructor,
  step: number = 1,
): moment.Moment[] => {
  const range = [];
  let current = start;
  while (current <= end) {
    range.push(current.clone());
    current = current.add(step, unit);
  }
  return range;
};

export const getColorByStatus = (
  status: 'optimal' | 'in-range' | 'attention' | 'default' | 'pending',
) => {
  if (status === 'attention') {
    return '#D2691E';
  } else if (status === 'in-range') {
    return '#006FFF';
  } else if (status === 'optimal') {
    return '#08A96F';
  }
  return '#4F5C6D';
};
